<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR CONSÓRCIO' : 'NOVO CONSÓRCIO'" titleIcon="fas fa-handshake">
            <el-form ref="dados" :model="dados" label-position="top" @submit.native.prevent="salvar">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Nome" prop="nome" :rules="$requiredBlur">
                            <el-input v-model="dados.nome" placeholder="Ex.: Consórcio Intermunicipal de Educação"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6">
                        <el-form-item label="CNPJ">
                            <el-input v-model="dados.cnpj" v-mask="'##.###.###/####-##'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6">
                        <el-form-item label="UF">
                            <el-input v-model="dados.uf" maxlength="2" placeholder="SC"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Papel desta instalação">
                    <el-radio-group v-model="dados.municipio_gestor">
                        <el-radio :label="true">Gestora — hospeda e publica o catálogo</el-radio>
                        <el-radio :label="false">Associada — consome o catálogo central</el-radio>
                    </el-radio-group>
                </el-form-item>

                <div v-if="!dados.municipio_gestor">
                    <el-alert type="info" :closable="false" class="u-mb-15"
                        title="Instalação associada precisa saber de onde puxar o catálogo e com qual credencial."
                        description="A URL e o token são fornecidos pela instalação gestora do consórcio."></el-alert>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="14">
                            <el-form-item label="URL do catálogo central" prop="url_catalogo" :rules="$requiredBlur">
                                <el-input v-model="dados.url_catalogo"
                                    placeholder="https://gestora.sc.gov.br/api/catalogo-consorcio"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="10">
                            <el-form-item label="Token de acesso">
                                <el-input v-model="dados.token_acesso" type="password" show-password
                                    :placeholder="temToken ? 'Preenchido — deixe em branco para manter' : 'Token fornecido pela gestora'"></el-input>
                                <small>Gravado criptografado. Nenhum endpoint devolve este valor.</small>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <el-form-item label="Situação">
                    <el-switch v-model="dados.situacao" active-text="Ativo" inactive-text="Inativo"></el-switch>
                </el-form-item>

                <div class="u-text-right u-mt-20">
                    <router-link to="/admin/consorcio"><el-button>CANCELAR</el-button></router-link>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" native-type="submit">SALVAR</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO M — itens 123 e 124. */
export default {
    data: () => ({
        temToken: false,
        dados: { nome: '', cnpj: '', uf: '', url_catalogo: '', token_acesso: '',
                 municipio_gestor: true, situacao: true }
    }),
    computed: {
        podeEscrever () { return [4, 5].includes(parseInt(this.$store.state.user.tipo)) },
        modoEdicao () { return !!this.$route.params.id }
    },
    mounted () {
        if (this.modoEdicao) {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/consorcio/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/consorcio')
                    return
                }
                Object.keys(this.dados).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k] })
                this.dados.token_acesso = ''
                this.temToken = !!reg.tem_token
            }).catch(e => this.$store.commit('throwException', e))
        }
    },
    methods: {
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/consorcio/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/consorcio/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Consórcio salvo.', type: 'success' })
                    this.$router.push('/admin/consorcio')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
